module Meevo.Components.Charts {

    export class ChartDirector {
        public static buildProductivityGoalsChart(lineChartBuilder: LineChartBuilder) {
            lineChartBuilder.buildBlock();
            lineChartBuilder.buildXTimeScale();
            lineChartBuilder.buildYLinearScale();
            lineChartBuilder.buildAxises();
            lineChartBuilder.buildLines();
            lineChartBuilder.buildLegend();
        }
    }
}
